import styles from "./icons.module.scss";

interface IconProps {
  className?: string;
  size?: number | string;
}

// Copy icon
export function CopyIcon({ className, size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M10.3918 0H7.27651C5.86529 0 4.74688 0 3.87246 0.118395C2.97165 0.239991 2.24284 0.495981 1.66843 1.07276C1.09322 1.64954 0.838013 2.38151 0.717211 3.28547C0.599609 4.16384 0.599609 5.28619 0.599609 6.70294V11.3732C0.599609 12.5795 1.33562 13.6131 2.38124 14.0466C2.32764 13.3187 2.32764 12.2987 2.32764 11.4492V7.44131C2.32764 6.41655 2.32764 5.53258 2.42204 4.82541C2.52364 4.06704 2.75244 3.34067 3.33965 2.75109C3.92686 2.16151 4.65087 1.93192 5.40609 1.82953C6.1101 1.73513 6.99011 1.73513 8.01173 1.73513H10.4678C11.4886 1.73513 12.367 1.73513 13.0718 1.82953C12.8607 1.29058 12.4921 0.827758 12.014 0.501407C11.5359 0.175056 10.9706 0.000324645 10.3918 0Z"
        fill="white"
        fillOpacity="0.64"
      />
      <path
        d="M3.47949 7.51794C3.47949 5.33723 3.47949 4.24687 4.1547 3.5693C4.82911 2.89172 5.91473 2.89172 8.08757 2.89172H10.3916C12.5636 2.89172 13.6501 2.89172 14.3253 3.5693C15.0005 4.24687 14.9997 5.33723 14.9997 7.51794V11.3738C14.9997 13.5545 14.9997 14.6449 14.3253 15.3224C13.6501 16 12.5636 16 10.3916 16H8.08757C5.91553 16 4.82911 16 4.1547 15.3224C3.47949 14.6449 3.47949 13.5545 3.47949 11.3738V7.51794Z"
        fill="white"
        fillOpacity="0.64"
      />
    </svg>
  );
}

// Telegram icon
export function TelegramIcon({ className, size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62348 15.0819L8.61472 15.0835L8.5582 15.1113L8.54228 15.1145L8.53114 15.1113L8.47462 15.0835C8.46613 15.0808 8.45976 15.0821 8.45551 15.0874L8.45233 15.0954L8.43879 15.4361L8.44277 15.452L8.45073 15.4624L8.53353 15.5213L8.54547 15.5245L8.55502 15.5213L8.63781 15.4624L8.64736 15.4497L8.65055 15.4361L8.63701 15.0962C8.63489 15.0877 8.63038 15.0829 8.62348 15.0819ZM8.83444 14.9919L8.82409 14.9935L8.67682 15.0675L8.66886 15.0755L8.66647 15.0843L8.6808 15.4266L8.68478 15.4361L8.69115 15.4417L8.85116 15.5157C8.86124 15.5184 8.86894 15.5163 8.87424 15.5094L8.87743 15.4982L8.85036 15.0094C8.84771 14.9999 8.8424 14.994 8.83444 14.9919ZM8.26525 14.9935C8.26174 14.9914 8.25755 14.9907 8.25354 14.9916C8.24954 14.9925 8.24603 14.9949 8.24376 14.9983L8.23898 15.0094L8.21191 15.4982C8.21244 15.5078 8.21696 15.5141 8.22545 15.5173L8.23739 15.5157L8.3974 15.4417L8.40536 15.4353L8.40854 15.4266L8.42208 15.0843L8.41969 15.0747L8.41173 15.0668L8.26525 14.9935Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3427 0.093508C14.5394 0.0107117 14.7547 -0.0178442 14.9662 0.0108122C15.1777 0.0394686 15.3777 0.12429 15.5453 0.256448C15.7129 0.388605 15.842 0.563268 15.9192 0.762255C15.9964 0.961243 16.0188 1.17728 15.9842 1.38788L14.1787 12.3391C14.0035 13.3955 12.8445 14.0013 11.8757 13.4751C11.0653 13.0349 9.8616 12.3566 8.77895 11.649C8.23763 11.2947 6.57942 10.1603 6.78321 9.35316C6.95834 8.66298 9.74458 6.06945 11.3367 4.5275C11.9616 3.92171 11.6766 3.57224 10.9387 4.12948C9.10614 5.51301 6.16387 7.61697 5.19107 8.20923C4.33291 8.73144 3.88552 8.8206 3.35056 8.73144C2.37458 8.56905 1.46945 8.3175 0.730701 8.01102C-0.267568 7.59707 -0.219008 6.22468 0.729905 5.82506L14.3427 0.093508Z"
        fill="white"
      />
    </svg>
  );
}

// Question icon
export function QuestionIcon({ className, size = 11 }: IconProps) {
  return (
    <svg
      width={size}
      height={size + 2}
      viewBox="0 0 11 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M7.03009 14.2086C7.03009 14.7277 6.82386 15.2256 6.45677 15.5927C6.08968 15.9598 5.5918 16.166 5.07266 16.166C4.55352 16.166 4.05564 15.9598 3.68855 15.5927C3.32146 15.2256 3.11523 14.7277 3.11523 14.2086C3.11523 13.6894 3.32146 13.1915 3.68855 12.8244C4.05564 12.4573 4.55352 12.2511 5.07266 12.2511C5.5918 12.2511 6.08968 12.4573 6.45677 12.8244C6.82386 13.1915 7.03009 13.6894 7.03009 14.2086Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.04438 3.00434C4.38865 3.00434 3.82589 3.20009 3.42951 3.48001C3.04781 3.75014 2.85892 4.06431 2.80411 4.33542C2.72313 4.69781 2.50333 5.01402 2.19189 5.21622C1.88045 5.41842 1.50216 5.49049 1.13819 5.41698C0.774218 5.34347 0.453556 5.13022 0.244998 4.823C0.03644 4.51577 -0.0433997 4.13904 0.0226078 3.77363C0.244776 2.67157 0.927917 1.77212 1.7931 1.16041C2.69352 0.524232 3.8347 0.166016 5.04438 0.166016C7.54695 0.166016 10.1415 1.83965 10.1415 4.52725C10.1415 6.08344 9.21664 7.34209 8.01869 8.07614C7.6976 8.27264 7.31161 8.33354 6.94562 8.24543C6.57963 8.15733 6.26364 7.92744 6.06714 7.60635C5.87064 7.28525 5.80975 6.89925 5.89785 6.53325C5.98595 6.16726 6.21583 5.85125 6.53692 5.65475C7.09479 5.31318 7.30325 4.87764 7.30325 4.52725C7.30325 3.96546 6.60347 3.00434 5.04438 3.00434Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.04413 6.78772C5.8271 6.78772 6.46327 7.42194 6.46327 8.20688V9.67694C6.46327 10.0533 6.31375 10.4143 6.04761 10.6804C5.78147 10.9466 5.42051 11.0961 5.04413 11.0961C4.66776 11.0961 4.30679 10.9466 4.04065 10.6804C3.77452 10.4143 3.625 10.0533 3.625 9.67694V8.20688C3.625 7.4239 4.26018 6.78772 5.04413 6.78772Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49804 6.13753C8.5939 6.29752 8.65729 6.47484 8.68458 6.65934C8.71187 6.84385 8.70252 7.03192 8.65707 7.21281C8.61162 7.3937 8.53097 7.56386 8.41971 7.71355C8.30845 7.86324 8.16878 7.98954 8.00868 8.08521L5.7733 9.42314C5.45039 9.61652 5.06389 9.67371 4.69882 9.58212C4.33375 9.49053 4.02002 9.25766 3.82664 8.93475C3.63326 8.61184 3.57607 8.22533 3.66766 7.86025C3.75925 7.49517 3.99211 7.18143 4.31502 6.98805L6.55138 5.64914C6.71132 5.55343 6.88855 5.49016 7.07295 5.46295C7.25735 5.43575 7.4453 5.44513 7.62607 5.49058C7.80685 5.53602 7.97689 5.61663 8.12651 5.7278C8.27612 5.83898 8.40237 5.97756 8.49804 6.13753Z"
        fill="white"
      />
    </svg>
  );
}

// Close filled icon
export function CloseFilledIcon({ className, size = 20 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M10.0367 0.398926C4.68748 0.398926 0.435547 4.65086 0.435547 10.0001C0.435547 15.3493 4.68748 19.6012 10.0367 19.6012C15.3859 19.6012 19.6378 15.3493 19.6378 10.0001C19.6378 4.65086 15.3859 0.398926 10.0367 0.398926ZM13.74 14.8006L10.0367 11.0973L6.33339 14.8006L5.23612 13.7034L8.93941 10.0001L5.23612 6.29677L6.33339 5.1995L10.0367 8.90279L13.74 5.1995L14.8373 6.29677L11.134 10.0001L14.8373 13.7034L13.74 14.8006Z"
        fill="white"
      />
    </svg>
  );
}

// Plus filled icon
export function PlusFilledIcon({ className, size = 36 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <rect width="36" height="36" rx="18" fill="white" />
      <path
        d="M16.1824 26V19.321H9.5V16.679H16.1824V10H18.8176V16.679H25.5V19.321H18.8176V26H16.1824Z"
        fill="#746A93"
      />
    </svg>
  );
}

// Reset icon
export function ResetIcon({ className, size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.16" />
      <path
        d="M12 6C8.65714 6 6 8.65714 6 12C6 15.3429 8.65714 18 12 18C15.3429 18 18 15.3429 18 12C18 8.65714 15.3429 6 12 6ZM14.3143 15L12 12.6857L9.68571 15L9 14.3143L11.3143 12L9 9.68571L9.68571 9L12 11.3143L14.3143 9L15 9.68571L12.6857 12L15 14.3143L14.3143 15Z"
        fill="white"
      />
    </svg>
  );
}


// Eye icon
export function EyeIcon({ className, size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
        fill="white"
      />
    </svg>
  );
}

// History icon
export function HistoryIcon({ className, size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size + 1}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M7 14.333C5.21111 14.333 3.65244 13.7401 2.324 12.5542C0.995555 11.3684 0.233852 9.88723 0.0388888 8.11078H1.63333C1.81481 9.45893 2.41448 10.5737 3.43233 11.4552C4.45018 12.3367 5.63941 12.7774 7 12.7774C8.51667 12.7774 9.80337 12.2493 10.8601 11.1931C11.9169 10.1369 12.445 8.85019 12.4444 7.33301C12.4439 5.81582 11.9158 4.52938 10.8601 3.47367C9.80441 2.41797 8.5177 1.8896 7 1.88856C6.10555 1.88856 5.26944 2.09597 4.49167 2.51079C3.71389 2.9256 3.05926 3.49597 2.52778 4.2219H4.66667V5.77745H0V1.11079H1.55556V2.93856C2.21667 2.10893 3.02374 1.46727 3.97678 1.01356C4.92981 0.55986 5.93755 0.333008 7 0.333008C7.97222 0.333008 8.883 0.51786 9.73233 0.887563C10.5817 1.25727 11.3206 1.75608 11.949 2.38401C12.5774 3.01193 13.0765 3.75082 13.4462 4.60067C13.8159 5.45053 14.0005 6.3613 14 7.33301C13.9995 8.30471 13.8149 9.21549 13.4462 10.0653C13.0776 10.9152 12.5785 11.6541 11.949 12.282C11.3195 12.9099 10.5806 13.409 9.73233 13.7792C8.88404 14.1494 7.97326 14.334 7 14.333ZM9.17778 10.5997L6.22222 7.64412V3.44412H7.77778V7.02189L10.2667 9.51078L9.17778 10.5997Z"
        fill="white"
      />
    </svg>
  );
}

// Credit card icon
export function CreditCardIcon({ className, size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size - 2}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <mask
        id="mask0_574_9489"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="12"
      >
        <path
          d="M8.40007 0.333008H5.6001C2.96044 0.333008 1.64025 0.333008 0.820565 1.1534C0.229772 1.74349 0.0645742 2.59328 0.0183748 4.00796H13.9818C13.9356 2.59328 13.7704 1.74349 13.1796 1.1534C12.3599 0.333008 11.0397 0.333008 8.40007 0.333008ZM5.6001 11.5329H8.40007C11.0397 11.5329 12.3599 11.5329 13.1796 10.7125C13.9993 9.89209 14 8.5726 14 5.93294C14 5.62401 13.9995 5.33235 13.9986 5.05795H0.00157504C0.000175053 5.33235 -0.000291673 5.62401 0.000174988 5.93294C0.000174988 8.5726 0.000174902 9.89279 0.820565 10.7125C1.64095 11.5322 2.96044 11.5329 5.6001 11.5329Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.27539 8.73288C2.27539 8.59364 2.3307 8.46011 2.42916 8.36165C2.52761 8.2632 2.66115 8.20789 2.80038 8.20789H5.60035C5.73959 8.20789 5.87312 8.2632 5.97158 8.36165C6.07003 8.46011 6.12534 8.59364 6.12534 8.73288C6.12534 8.87212 6.07003 9.00565 5.97158 9.10411C5.87312 9.20256 5.73959 9.25787 5.60035 9.25787H2.80038C2.66115 9.25787 2.52761 9.20256 2.42916 9.10411C2.3307 9.00565 2.27539 8.87212 2.27539 8.73288ZM6.82533 8.73288C6.82533 8.59364 6.88065 8.46011 6.9791 8.36165C7.07756 8.2632 7.21109 8.20789 7.35033 8.20789H8.40031C8.53955 8.20789 8.67309 8.2632 8.77154 8.36165C8.87 8.46011 8.92531 8.59364 8.92531 8.73288C8.92531 8.87212 8.87 9.00565 8.77154 9.10411C8.67309 9.20256 8.53955 9.25787 8.40031 9.25787H7.35033C7.21109 9.25787 7.07756 9.20256 6.9791 9.10411C6.88065 9.00565 6.82533 8.87212 6.82533 8.73288Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_574_9489)">
        <path
          d="M-1.39941 -2.46692H15.4004V14.3329H-1.39941V-2.46692Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

// Promo icon
export function PromoIcon({ className, size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size + 1}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M3.0625 6.29102C2.21667 6.29102 1.49479 5.99206 0.896875 5.39414C0.298958 4.79622 0 4.07435 0 3.22852C0 2.38268 0.298958 1.66081 0.896875 1.06289C1.49479 0.464974 2.21667 0.166016 3.0625 0.166016C3.90833 0.166016 4.63021 0.464974 5.22813 1.06289C5.82604 1.66081 6.125 2.38268 6.125 3.22852C6.125 4.07435 5.82604 4.79622 5.22813 5.39414C4.63021 5.99206 3.90833 6.29102 3.0625 6.29102ZM3.0625 4.54102C3.42708 4.54102 3.73712 4.41356 3.99262 4.15864C4.24812 3.90372 4.37558 3.59368 4.375 3.22852C4.37442 2.86335 4.24696 2.5536 3.99262 2.29927C3.73829 2.04493 3.42825 1.91718 3.0625 1.91602C2.69675 1.91485 2.387 2.0426 2.13325 2.29927C1.8795 2.55593 1.75175 2.86568 1.75 3.22852C1.74825 3.59135 1.876 3.90139 2.13325 4.15864C2.3905 4.41589 2.70025 4.54335 3.0625 4.54102ZM10.9375 14.166C10.0917 14.166 9.36979 13.8671 8.77187 13.2691C8.17396 12.6712 7.875 11.9493 7.875 11.1035C7.875 10.2577 8.17396 9.53581 8.77187 8.93789C9.36979 8.33997 10.0917 8.04102 10.9375 8.04102C11.7833 8.04102 12.5052 8.33997 13.1031 8.93789C13.701 9.53581 14 10.2577 14 11.1035C14 11.9493 13.701 12.6712 13.1031 13.2691C12.5052 13.8671 11.7833 14.166 10.9375 14.166ZM10.9375 12.416C11.3021 12.416 11.6121 12.2886 11.8676 12.0336C12.1231 11.7787 12.2506 11.4687 12.25 11.1035C12.2494 10.7383 12.122 10.4286 11.8676 10.1743C11.6133 9.91993 11.3033 9.79218 10.9375 9.79102C10.5717 9.78985 10.262 9.9176 10.0082 10.1743C9.7545 10.4309 9.62675 10.7407 9.625 11.1035C9.62325 11.4663 9.751 11.7764 10.0082 12.0336C10.2655 12.2909 10.5752 12.4183 10.9375 12.416ZM1.225 14.166L0 12.941L12.775 0.166016L14 1.39102L1.225 14.166Z"
        fill="white"
      />
    </svg>
  );
}

// Menu icon
export function MenuIcon({ className, size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size - 4}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <rect width="5" height="2" rx="1" fill="white" />
      <rect x="11" y="10" width="5" height="2" rx="1" fill="white" />
      <rect x="7" width="9" height="2" rx="1" fill="white" />
      <rect y="10" width="9" height="2" rx="1" fill="white" />
      <rect y="5" width="16" height="2" rx="1" fill="white" />
    </svg>
  );
}

// Support icon
export function SupportIcon({ className, size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M11 21V19H19V11.9C19 9.95 18.321 8.296 16.963 6.938C15.605 5.58 13.9507 4.90067 12 4.9C10.0493 4.89933 8.39533 5.57867 7.038 6.938C5.68067 8.29733 5.00133 9.95133 5 11.9V18H2V12.275H3L3.075 10.95C3.20833 9.81667 3.53767 8.76667 4.063 7.8C4.58833 6.83333 5.24667 5.99167 6.038 5.275C6.82933 4.55833 7.73733 4 8.762 3.6C9.78667 3.2 10.866 3 12 3C13.134 3 14.209 3.2 15.225 3.6C16.241 4 17.1493 4.55433 17.95 5.263C18.7507 5.97167 19.409 6.809 19.925 7.775C20.441 8.741 20.7743 9.791 20.925 10.925L21 12.275H22V18H21V21H11ZM9 14C8.71667 14 8.47933 13.904 8.288 13.712C8.09667 13.52 8.00067 13.2827 8 13C7.99933 12.7173 8.09533 12.48 8.288 12.288C8.48067 12.096 8.718 12 9 12C9.282 12 9.51967 12.096 9.713 12.288C9.90633 12.48 10.002 12.7173 10 13C9.998 13.2827 9.902 13.5203 9.712 13.713C9.522 13.9057 9.28467 14.0013 9 14ZM15 14C14.7167 14 14.4793 13.904 14.288 13.712C14.0967 13.52 14.0007 13.2827 14 13C13.9993 12.7173 14.0953 12.48 14.288 12.288C14.4807 12.096 14.718 12 15 12C15.282 12 15.5197 12.096 15.713 12.288C15.9063 12.48 16.002 12.7173 16 13C15.998 13.2827 15.902 13.5203 15.712 13.713C15.522 13.9057 15.2847 14.0013 15 14ZM6.025 12.45C5.90833 10.6833 6.44167 9.16667 7.625 7.9C8.80833 6.63333 10.2833 6 12.05 6C13.5333 6 14.8377 6.47067 15.963 7.412C17.0883 8.35333 17.7673 9.558 18 11.026C16.4833 11.0087 15.0877 10.6 13.813 9.8C12.5383 9 11.559 7.91667 10.875 6.55C10.6083 7.88333 10.046 9.071 9.188 10.113C8.33 11.155 7.27567 11.934 6.025 12.45Z"
        fill="white"
      />
    </svg>
  );
}

// Back icon
export function BackIcon({ className, size = 14 }: IconProps) {
  return (
    <svg
      width={size}
      height={size + 2}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M0.292893 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM14 8V7L1 7V8V9L14 9V8Z"
        fill="white"
      />
    </svg>
  );
}

// Loop icon
export function LoopIcon({ className, size = 18 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.146 12.3707 1.888 11.112C0.63 9.85333 0.000667196 8.316 5.29101e-07 6.5C-0.000666138 4.684 0.628667 3.14667 1.888 1.888C3.14733 0.629333 4.68467 0 6.5 0C8.31533 0 9.853 0.629333 11.113 1.888C12.373 3.14667 13.002 4.684 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.81267 10.5627 9.688 9.688C10.5633 8.81333 11.0007 7.75067 11 6.5C10.9993 5.24933 10.562 4.187 9.688 3.313C8.814 2.439 7.75133 2.00133 6.5 2C5.24867 1.99867 4.18633 2.43633 3.313 3.313C2.43967 4.18967 2.002 5.252 2 6.5C1.998 7.748 2.43567 8.81067 3.313 9.688C4.19033 10.5653 5.25267 11.0027 6.5 11Z"
        fill="white"
      />
    </svg>
  );
}

// Ico question icon
export function IcoQuestionIcon({ className, size = 9 }: IconProps) {
  return (
    <svg
      width={size}
      height={size + 6}
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M0.000352911 3.82019C-0.0019189 3.87415 0.00679616 3.92802 0.0259618 3.97847C0.0451275 4.02892 0.0743386 4.07489 0.111799 4.11355C0.14926 4.15221 0.194179 4.18275 0.243793 4.20328C0.293407 4.22382 0.346667 4.23391 0.4003 4.23295H1.76941C1.99843 4.23295 2.18098 4.04412 2.21085 3.81517C2.36021 2.71892 3.107 1.92012 4.43794 1.92012C5.57638 1.92012 6.61857 2.49332 6.61857 3.87199C6.61857 4.93316 5.9979 5.42112 5.01712 6.1631C3.90025 6.98028 3.01572 7.93449 3.07879 9.48362L3.08376 9.84626C3.08551 9.9559 3.12999 10.0605 3.2076 10.1374C3.28522 10.2143 3.38975 10.2574 3.49865 10.2574H4.84453C4.95456 10.2574 5.06009 10.2133 5.1379 10.135C5.2157 10.0566 5.25941 9.95037 5.25941 9.83957V9.6641C5.25941 8.46424 5.71246 8.11497 6.93554 7.18082C7.9462 6.40709 9 5.54813 9 3.74499C9 1.21992 6.88244 0 4.56407 0C2.46144 0 0.158009 0.985962 0.000352911 3.82019ZM2.58424 13.4509C2.58424 14.3416 3.28955 15 4.26037 15C5.27103 15 5.96637 14.3416 5.96637 13.4509C5.96637 12.5284 5.26937 11.88 4.25871 11.88C3.28955 11.88 2.58424 12.5284 2.58424 13.4509Z"
        fill="white"
      />
    </svg>
  );
}

// Order status success icon
export function OrderStatusSuccessIcon({ className, size = 28 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <foreignObject x="-16" y="-16" width="60" height="60">
        <div
          xmlns="http://www.w3.org/2000/xhtml"
          className={styles.foreignObjectDiv}
        />
      </foreignObject>
      <g data-figma-bg-blur-radius="16">
        <rect width="28" height="28" rx="14" fill="white" fillOpacity="0.16" />
        <path
          d="M11.8957 19.1642L7 14.2685L8.22393 13.0445L11.8957 16.7163L19.7761 8.83594L21 10.0599L11.8957 19.1642Z"
          fill="#00FF44"
        />
      </g>
      <defs>
        <clipPath id="bgblur_0_574_8991_clip_path" transform="translate(16 16)">
          <rect width="28" height="28" rx="14" />
        </clipPath>
      </defs>
    </svg>
  );
}

// Order status processing icon
export function OrderStatusProcessingIcon({ className, size = 28 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <foreignObject x="-16" y="-16" width="60" height="60">
        <div
          xmlns="http://www.w3.org/2000/xhtml"
          className={styles.foreignObjectDivProcessing}
        />
      </foreignObject>
      <g data-figma-bg-blur-radius="16">
        <rect width="28" height="28" rx="14" fill="white" fillOpacity="0.16" />
        <path
          d="M14 20C12.6 20 11.3611 19.5751 10.2833 18.7253C9.20556 17.8756 8.50556 16.7893 8.18333 15.4667C8.13889 15.3 8.17222 15.1473 8.28333 15.0087C8.39444 14.87 8.54444 14.7893 8.73333 14.7667C8.91111 14.7444 9.07222 14.7778 9.21667 14.8667C9.36111 14.9556 9.46111 15.0889 9.51667 15.2667C9.78333 16.2667 10.3333 17.0833 11.1667 17.7167C12 18.35 12.9444 18.6667 14 18.6667C15.3 18.6667 16.4029 18.214 17.3087 17.3087C18.2144 16.4033 18.6671 15.3004 18.6667 14C18.6662 12.6996 18.2136 11.5969 17.3087 10.692C16.4038 9.78711 15.3009 9.33422 14 9.33333C13.2333 9.33333 12.5167 9.51111 11.85 9.86667C11.1833 10.2222 10.6222 10.7111 10.1667 11.3333H11.3333C11.5222 11.3333 11.6807 11.3973 11.8087 11.5253C11.9367 11.6533 12.0004 11.8116 12 12C11.9996 12.1884 11.9356 12.3469 11.808 12.4753C11.6804 12.6038 11.5222 12.6676 11.3333 12.6667H8.66667C8.47778 12.6667 8.31956 12.6027 8.192 12.4747C8.06444 12.3467 8.00044 12.1884 8 12V9.33333C8 9.14444 8.064 8.98622 8.192 8.85867C8.32 8.73111 8.47822 8.66711 8.66667 8.66667C8.85511 8.66622 9.01356 8.73022 9.142 8.85867C9.27044 8.98711 9.33422 9.14533 9.33333 9.33333V10.2333C9.9 9.52222 10.5918 8.97222 11.4087 8.58333C12.2256 8.19444 13.0893 8 14 8C14.8333 8 15.614 8.15844 16.342 8.47533C17.07 8.79222 17.7033 9.21978 18.242 9.758C18.7807 10.2962 19.2084 10.9296 19.5253 11.658C19.8422 12.3864 20.0004 13.1671 20 14C19.9996 14.8329 19.8413 15.6136 19.5253 16.342C19.2093 17.0704 18.7816 17.7038 18.242 18.242C17.7024 18.7802 17.0691 19.208 16.342 19.5253C15.6149 19.8427 14.8342 20.0009 14 20ZM14.6667 13.7333L16.3333 15.4C16.4556 15.5222 16.5167 15.6778 16.5167 15.8667C16.5167 16.0556 16.4556 16.2111 16.3333 16.3333C16.2111 16.4556 16.0556 16.5167 15.8667 16.5167C15.6778 16.5167 15.5222 16.4556 15.4 16.3333L13.5333 14.4667C13.4667 14.4 13.4167 14.3251 13.3833 14.242C13.35 14.1589 13.3333 14.0727 13.3333 13.9833V11.3333C13.3333 11.1444 13.3973 10.9862 13.5253 10.8587C13.6533 10.7311 13.8116 10.6671 14 10.6667C14.1884 10.6662 14.3469 10.7302 14.4753 10.8587C14.6038 10.9871 14.6676 11.1453 14.6667 11.3333V13.7333Z"
          fill="#FFEE00"
        />
      </g>
      <defs>
        <clipPath id="bgblur_0_574_8925_clip_path" transform="translate(16 16)">
          <rect width="28" height="28" rx="14" />
        </clipPath>
      </defs>
    </svg>
  );
}

// Check icon
export function CheckIcon({ className, size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M6.5 12L2.5 8L3.5 7L6.5 10L12.5 4L13.5 5L6.5 12Z"
        fill="white"
      />
    </svg>
  );
}

// Pencil/Edit icon
export function PencilIcon({ className, size = 16 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M11.3333 2.66667C11.5083 2.49167 11.7167 2.40417 11.9583 2.40417C12.2 2.40417 12.4083 2.49167 12.5833 2.66667C12.7583 2.84167 12.8458 3.05 12.8458 3.29167C12.8458 3.53333 12.7583 3.74167 12.5833 3.91667L4.25 12.25L1.33333 13.3333L2.41667 10.4167L10.75 2.08333C10.925 1.90833 11.1333 1.82083 11.375 1.82083C11.6167 1.82083 11.825 1.90833 12 2.08333L11.3333 2.66667Z"
        fill="white"
      />
    </svg>
  );
}

// Pen icon (from Figma design system)
export function PenIcon({ className, size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        fill="currentColor"
      />
    </svg>
  );
}

// Trash icon (21x24 from Figma)
export function TrashIcon({ className, size = 24 }: IconProps) {
  const numSize = typeof size === "string" ? parseInt(size, 10) : size;
  const width = Math.round((numSize / 24) * 21);
  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M3.9375 24C3.21563 24 2.59787 23.7391 2.08425 23.2173C1.57062 22.6956 1.31337 22.0676 1.3125 21.3333V4H0V1.33333H6.5625V0H14.4375V1.33333H21V4H19.6875V21.3333C19.6875 22.0667 19.4307 22.6947 18.9171 23.2173C18.4034 23.74 17.7853 24.0009 17.0625 24H3.9375ZM6.5625 18.6667H9.1875V6.66667H6.5625V18.6667ZM11.8125 18.6667H14.4375V6.66667H11.8125V18.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Info icon
export function InfoIcon({ className, size = 22 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M11.917 6.41602H10.084V8.24935H11.917V6.41602ZM11.917 10.0827H10.084V15.5827H11.917V10.0827ZM11.0003 1.83268C5.94033 1.83268 1.83366 5.93935 1.83366 10.9993C1.83366 16.0593 5.94033 20.166 11.0003 20.166C16.0603 20.166 20.167 16.0593 20.167 10.9993C20.167 5.93935 16.0603 1.83268 11.0003 1.83268ZM11.0003 18.3327C6.95783 18.3327 3.66699 15.0418 3.66699 10.9993C3.66699 6.95685 6.95783 3.66602 11.0003 3.66602C15.0428 3.66602 18.3337 6.95685 18.3337 10.9993C18.3337 15.0418 15.0428 18.3327 11.0003 18.3327Z"
        fill="white"
      />
    </svg>
  );
}

